import { Button, Flex, Stack } from '@chakra-ui/react';
import useDsbFormsQuery from 'hooks/useDsbFormsQuery';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCar } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { DataTable } from '../../components/Table/DataTable';
import { ContentCard } from '../../layout/ContentCard';

const FormCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dsbFormsQuery = useDsbFormsQuery();

  const columns = useMemo(
    () => [
      {
        Header: t('pages:config_forms.table.columns.id'),
        accessor: 'id',
      },
      {
        Header: t('forms:slug.label'),
        accessor: 'slug',
      },
      {
        Header: t('pages:config_forms.table.columns.description'),
        accessor: 'description',
      },
      {
        id: 'details',
        accessor: 'id',
        // @ts-ignore
        Cell: (cellProps) => {
          const { row } = cellProps;

          return (
            <Flex alignContent={'flex-end'}>
              <Button
                ml={'auto'}
                variant={'primary'}
                onClick={() => {
                  navigate(`/app/op/dsb-form/${row?.original.id}`);
                }}
              >
                {t('common:details')}
              </Button>
            </Flex>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dsbFormsQuery.data],
  );
  if (dsbFormsQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <ContentCard
      isLoading={dsbFormsQuery.isFetching}
      icon={<AiFillCar size={'40px'} />}
      minH="fit-content"
      header={t('pages:config_forms.table.header_forms')}
      contentDescription={t('pages:config_forms.table.description')}
      data-test-id="make-card"
    >
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w={'100%'}>
          <DataTable
            data-test-id="forms-table"
            data={dsbFormsQuery.data as unknown as any[]}
            hasFilters={false}
            columns={columns}
            loading={dsbFormsQuery.isFetching}
            isMoreThenOnePage={false}
            hasSearchInput={undefined as any}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default FormCard;
